// Time zones offered for the web display zone (Profile → Personal details).
// The offset label is computed (DST-aware); the city is shown in the UI language.
import i18n from '@/i18n';

const TIMEZONES: Array<[string, string]> = [
  ['Europe/Moscow', 'moscow'], ['Europe/Berlin', 'berlin'], ['Europe/London', 'london'], ['Asia/Dubai', 'dubai'],
  ['Asia/Almaty', 'almaty'], ['Asia/Tokyo', 'tokyo'], ['America/New_York', 'newYork'], ['UTC', 'utc'],
];
/** [IANA zone, city in the UI language] */
export const timezones = (): Array<[string, string]> => TIMEZONES.map(([z, k]) => [z, i18n.t(`profile:tz.${k}`)]);
export const tzCity = (zone: string) => timezones().find(([z]) => z === zone)?.[1] ?? zone;
